// extracted by mini-css-extract-plugin
export var chip = "_md-0";
export var icon = "_md-1";
export var remove = "_md-2";
export var removeIcon = "_md-3";